const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardBondScore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14127"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14126"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34014",
    d: "M1616.266 2830h59.027a5.422 5.422 0 0 1 5.366 5.473v77.055a5.422 5.422 0 0 1-5.366 5.473h-59.027a5.422 5.422 0 0 1-5.366-5.473v-77.055a5.422 5.422 0 0 1 5.366-5.473z",
    transform: "translate(-1610.9 -2830)",
    style: {
      fill: "#6b7de5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34017",
    d: "M1710.5 3246.432a1.938 1.938 0 0 0 1.932 1.932h44.431a1.938 1.938 0 0 0 1.932-1.932 1.938 1.938 0 0 0-1.932-1.932h-44.431a1.938 1.938 0 0 0-1.932 1.932z",
    transform: "translate(-1699.811 -3199.091)",
    style: {
      opacity: 0.4,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34018",
    d: "M1995.5 3138.432a1.937 1.937 0 0 0 1.932 1.932h13.844a1.937 1.937 0 0 0 1.932-1.932 1.938 1.938 0 0 0-1.932-1.932h-13.844a1.937 1.937 0 0 0-1.932 1.932z",
    transform: "translate(-1954.224 -3110.098)",
    style: {
      opacity: 0.4,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34488",
    d: "M1995.5 3138.432a1.937 1.937 0 0 0 1.932 1.932h13.844a1.937 1.937 0 0 0 1.932-1.932 1.938 1.938 0 0 0-1.932-1.932h-13.844a1.937 1.937 0 0 0-1.932 1.932z",
    transform: "translate(-1954.224 -3102.922)",
    style: {
      opacity: 0.4,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34019",
    d: "M1995.5 3030.432a1.937 1.937 0 0 0 1.932 1.931h13.844a1.938 1.938 0 0 0 1.932-1.931 1.938 1.938 0 0 0-1.932-1.932h-13.844a1.938 1.938 0 0 0-1.932 1.932z",
    transform: "translate(-1954.224 -3010.304)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34020",
    d: "M1710.5 3354.432a1.937 1.937 0 0 0 1.932 1.932h44.431a1.937 1.937 0 0 0 1.932-1.932 1.937 1.937 0 0 0-1.932-1.932h-44.431a1.937 1.937 0 0 0-1.932 1.932z",
    transform: "translate(-1699.811 -3295.259)",
    style: {
      opacity: 0.4,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34021",
    d: "M1710.5 3462.432a1.938 1.938 0 0 0 1.932 1.932h44.431a1.938 1.938 0 0 0 1.932-1.932 1.938 1.938 0 0 0-1.932-1.932h-44.431a1.938 1.938 0 0 0-1.932 1.932z",
    transform: "translate(-1699.811 -3391.427)",
    style: {
      opacity: 0.4,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11299"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34015",
    d: "M1713.614 2970.8h20.05a3.07 3.07 0 0 1 2.914 3.2v19.473a3.07 3.07 0 0 1-2.914 3.2h-20.05a3.07 3.07 0 0 1-2.914-3.2V2974a3.07 3.07 0 0 1 2.914-3.2z",
    transform: "translate(-1699.917 -2959.962)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.845 12.884V11.8A2.171 2.171 0 0 1 2.1 9.94a14.433 14.433 0 0 1 10.759 0 2.171 2.171 0 0 1 1.257 1.86v1.085A2.213 2.213 0 0 1 11.9 15.1H3.061a2.213 2.213 0 0 1-2.216-2.216zM7.482 0a3.688 3.688 0 1 0 3.687 3.687A3.688 3.688 0 0 0 7.482 0z",
    transform: "translate(15.329 16.229)",
    style: {
      fill: "#19e8b7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.915 53.915)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2040",
    cx: 17.043,
    cy: 17.043,
    r: 17.043,
    style: {
      fill: "#20cea5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2041",
    cx: 13.973,
    cy: 13.973,
    r: 13.973,
    transform: "translate(3.069 3.069)",
    style: {
      fill: "#19e8b7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11228"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34022",
    d: "m2164.82 3433.249-5.237-5.044a1.39 1.39 0 0 1-.032-1.964 1.39 1.39 0 0 1 1.964-.032l3.338 3.22 7.663-7.147a1.39 1.39 0 0 1 1.964.064 1.39 1.39 0 0 1-.064 1.964z",
    transform: "translate(-2149.967 -3410.539)",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBondScore);
export default __webpack_public_path__ + "static/media/dashboard_bond_score.e22b75d077be3c55786e211005022788.svg";
export { ForwardRef as ReactComponent };